module.exports = __webpack_public_path__ + "img/personal.480a8c28.svg";